import React from 'react';
import {observer} from 'mobx-react';
import localeText from '@locale';
import image from '~/assets/images/no_message_dark.svg';
import MobileNavBack from '~/components/MobileNavBack';
import {ALARM_MESSAGE_LENGTH} from '~/utils/constants';
import WebsocketService from '~/services/websocketService';
import './mobile.less';

@observer
class MessageDetailOnMobile extends React.Component {
  showAllOnMobile = () => {
    const {messageStore} = this.props;
    messageStore.toggleMessagePoPUp(!messageStore.showMessage);
    window.$sdk$.switchPage({
      appId: messageStore.currentApp.linkedAppId,
      menuCode: messageStore.currentApp.linkedMenuCode,
      state: messageStore.currentApp.linkedStates
    });
  };

  // 加载更多
  loadMore = () => {
    const {messageStore} = this.props;
    messageStore.setLoading(true);
    WebsocketService.send(JSON.stringify({
      appId: messageStore.currentApp.id,
      currentPage: 0
    }));
  }

  render() {
    const {messageStore, renderAppsOnMobile, renderMessages} = this.props;
    return (
      <div className={messageStore.showMessage ? 'message-detail-onMobile' : 'message-detail-onMobile hidden'}>
        <MobileNavBack {...{[['key'][0]]: 'message-nav-back'}} title={localeText('MESSAGE.TXT_MESSAGE')} onClose={() => messageStore.toggleMessagePoPUp(false)} />
        {renderAppsOnMobile()}
        {messageStore.apps.length ? (
          <div className='message-content'>
            <div className='message-list'>
              {renderMessages(messageStore.currentApp && messageStore.currentApp.messages)}
              {
                // eslint-disable-next-line max-len
                (messageStore.currentApp.messages?.length < ALARM_MESSAGE_LENGTH) && (messageStore.currentApp.messages?.length < messageStore.currentApp?.count) && (
                  <div
                    className='load-more'
                    onClick={() => this.loadMore()}
                  >
                    <i className={messageStore.loading ? 'dplicon_loading' : 'dplicon_refresh'} />
                    {
                      messageStore.isLoadFailed ? (
                        <span>
                          {localeText('MESSAGE.TXT_LOAD_FAILED')}
                        </span>
                      ) : (
                        <span>
                          {messageStore.loading ? localeText('MESSAGE.TXT_LOADING') : localeText('MESSAGE.TXT_LOAD_MORE')}
                        </span>
                      )
                    }
                  </div>
                )
              }
            </div>

            {messageStore.currentApp.linkedAppId
           && (
             <div className='show-all' onClick={this.showAll}>
               {localeText('MESSAGE.TXT_SHOW_ALL')}
             </div>
           ) }
          </div>
        ) : (
          <div className='no-message'>
            <img src={image} alt='404' />
            <span className='no-message-hint'>{localeText('MESSAGE.TXT_NO_MESSAGE')}</span>
          </div>
        )}
      </div>
    );
  }
}

export default MessageDetailOnMobile;
